import { Cliente } from "./cliente";

export interface DocumentoElectronico {
    id: string;
    fechaEmisionDE?: string;
    estadoInicial?: number;
    pagoId?: number;
    cdc?: string;
    codigoSeguridad?: string;
    numeroDocumento?: number;
    serieDocumento?: string;
    establecimiento?: string;
    puntoExpedicion?: string;
    observaciones?: string;
    estado?: number;
    tipoDocumento: number;
    nombreReceptor?: string;
    rucReceptor?: string;
    dvReceptor?: string;
    docReceptor?: string;
    direccionReceptor?: string;
    emailReceptor?: string;
    emailReceptorActual?: string;
    timbrado: string;
    numeroLote?: string;
    subIva5: number;
    subIva10: number;
    subIvaExe: number;
    total: number;
    isCobroComision?: boolean;
    fechaProceso?: string;
    codigoProceso?: string;
    descripcionProceso?: string;
    tituloProceso?: string;
    respuestaProceso?: string;
    respuestasSifen?: RespuestaSifen[];
    estadoProceso?: number;
    fechaCreacion?: string;
    fechaModificacion?: string;
    creadoPor?: string;
    modificadoPor?: string;
    hasVenta?: boolean;
    ventaBorrada?: boolean | null;
    numeroVenta?: number;
    cMoneOpe?: string;
    dTiCam?: number;
    nombreVendedor?: string;
    docVendedor?: string;
    direccionVendedor?: string;
    emailVendedor?: string;
    tipoDocumentoAsociado?: number;
    cdcDocumentoAsociado?: string;
}

export interface RespuestaSifen {
    fecha?: string;
    codigo?: string;
    titulo?: string;
    descripcion?: string;
    numeroLote?: string;
}

export interface DocumentoElectronicoDetalles extends DocumentoElectronico {
    items?: ItemDetalle[];
    cliente?: Cliente;
    tipoTransaccion?: string;
    condicionOperacion?: string;
    formasPago?: FormaPagoDetalle[];
    credito?: CreditoDetalle;
    cMoneOpe?: string;
    dTiCam?: number;
}

export interface ItemDetalle {
    codigo?: string;
    descripcion?: string;
    unidadMedida?: number;
    cantidad?: number;
    precio?: number;
    total?: number;
    iva?: number;
}

export interface FormaPagoDetalle {
    tipoPago?: number;
    monto?: number;
    moneda?: string;
    tipoCambio?: number;
}

export interface CreditoDetalle {
    tipoCredito?: number;
    plazoCredito?: string;
    cantidadCuotas?: number;
    cuotas?: CuotaDetalle[];
}

export interface CuotaDetalle {
    descripcion?: string;
    monto?: number;
    fechaVencimiento?: string;
}

export interface DocumentosElectronicosQuery {
    cdc?: string;
    numeroDocumento?: number;
    estado?: number;
    estadoInicial?: number;
    estadoProceso?: number;
    tipoDocumento?: number;
    nombreReceptor?: string;
    establecimiento?: string;
    puntoExpedicion?: string;
    fechaEmisionDesde?: string;
    fechaEmisionHasta?: string;
    fechaProcesoDesde?: string;
    fechaProcesoHasta?: string;
    page?: number;
    pageSize?: number;
}

// Enums matching backend
export enum DEEstadoEnum {
    Inactivo = 0,
    Activo = 1,
    Cancelado = 2,
    Inutilizado = 3,
    Devuelto = 4,
    Reservado = 5
}

export enum DEEstadoInicialEnum {
    NoEnviado = 0,
    Procesado = 1,
    EnSifen = 2,
    ErrorEnvio = 4
}

export enum DEEstadoProcesoEnum {
    Aprobado = 0,
    AprobadoConObservacion = 1,
    Rechazado = 2,
    EnProceso = 3
}

export enum DETipoDocumentoEnum {
    FacturaElectronica = 1,
    FacturaElectronicaExportaion = 2,
    FacturaElectronicaImportacion = 3,
    Autofactura = 4,
    NotaCredito = 5,
    NotaRemision = 7,
}

export enum DETipoDocumentoAsociadoEnum {
    Electronico = "1",
    Impreso = "2",
    ConstanciaElectronica = "3"
}

export enum DETipoConstanciaAsociadoEnum {
    DeNoSerContribuyente = "1",
    DeMicroproductores = "2",
}

export const LENGTH_CDC = 44;